// removed by extract-text-webpack-plugin
module.exports = {"starBlock":"_1z7rVSrPReYjWs5_8tSCdN","cover":"_2t20ByUKkfr5DXgn_m6ggP","img":"_2rCvCErHKYUKqwasoTLcbM","noImg":"_11XaD4lNiStvL4v7ExmrYH","expandBtn":"_1Cp3ysJiKDwVbl_zxNWDm7","name":"_2Gw34NRPci5njZLML01kKE","isExpand":"_28NTG068uOFxvf3QytQSkf","info":"YwCgII9WzHFmhXzc0E2At","isEng":"_3zL7nCdeoSIHHok-1oyvAa","mobileInfo":"_1iyYM9Hganhw8PA6WSVXZV","mobileExpandButton":"bowXpQnYTHuCeCRSDhV8B","bgImg":"_2TkAGVS0vhQ6YqaZGDR2g","isCenter":"l0WTDeNqmRMIoaM8N0dmA","p":"_2626EmusOUEtvw4UVzH4Ju"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StarBlock/StarBlock.css
// module id = 181
// module chunks = 0